var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-12 text-center"},[_c('span',[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"blind"}})],1),_c('h1',[_vm._v(_vm._s(_vm.$t('sorry')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('page-not-found'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }